import React, { forwardRef, useEffect, useState } from 'react'
import {
	StyledPhotoEditorPhotoCameraContainer,
	StyledPhotoEditorPhotoCameraImg,
	StyledPhotoEditorWatermarkImg,
} from 'components/Selfiebooth/PhotoEditor/styled'
import Sticker from 'components/Selfiebooth/PhotoEditor/sticker';
import { StickerSelfieBoothType, WatermarkSelfieBoothType } from '../../../types/selfiebooth'

interface PhotoCameraProps {
	photoUrl: string;
	stickers: StickerSelfieBoothType[];
	watermark: WatermarkSelfieBoothType;
	selectedStickerId: string|null;
	updateSticker: (id: string, updates: Partial<any>) => void;
	deleteSticker: (id: string) => void;
	selectSticker: (id: string) => void;
	imageRotation: number;
	isModal: boolean;
}

const PhotoCamera = forwardRef<HTMLDivElement, PhotoCameraProps>(
	({ photoUrl, stickers, watermark, selectedStickerId, updateSticker, deleteSticker, selectSticker, imageRotation, isModal }, ref) => {
		const [watermarkSize, setWatermarkSize] = useState<{width: number; height: number;}>({ width: 0, height: 0 });

		useEffect(() => {
			if (!watermark?.url) return;

			const img = new Image();
			img.src = watermark.url;
			img.onload = () => {
				setWatermarkSize({ width: img.naturalWidth, height: img.naturalHeight });
			};
		}, [watermark?.url]);

		return (
			<StyledPhotoEditorPhotoCameraContainer ref={ref}>
				<StyledPhotoEditorPhotoCameraImg src={photoUrl} $imageRotation={imageRotation} />

				{stickers.map((sticker) => (
					<Sticker
						key={sticker.id}
						sticker={sticker}
						onUpdate={updateSticker}
						onDelete={deleteSticker}
						onSelect={selectSticker}
						isSelected={sticker.id === selectedStickerId}
					/>
				))}

				{watermark.isUse && <StyledPhotoEditorWatermarkImg
					src={watermark.url}
					$size={watermark.size}
					$width={watermarkSize.width}
					$height={watermarkSize.height}
					$position={watermark.position}
					$opacity={watermark.opacity}
				/>}
			</StyledPhotoEditorPhotoCameraContainer>
		);
	}
);

export default PhotoCamera;
